// Lo que se lee encima del súper 3D (inicio, plano 6, y Productos): la conversación del
// celular de la caja (Yvyra) y la vista de la cámara del techo (Tajy). Es una escena de
// ejemplo: el comercio, el cliente y la conversación son inventados; el precio y el
// stock son los de la góndola del dibujo (world/market/catalog.ts).
//
// Guía 8.5 y 10: Tajy está en desarrollo; muestra caídas, aforo y faltantes. Nada de
// "robo", "hurto" ni "seguridad" como algo que ya funciona. Ninguna alerta sobre una
// persona sale sin que alguien la confirme.

import { CATALOG, priceText } from "@/world/market/catalog";

const yerba = CATALOG.find((p) => p.id === "yerba")!;
const price = priceText(yerba.price);

export const marketDemo = {
  /** La yerba consultada, en la góndola: lo que quedó en el estante. */
  query: { name: `${yerba.label} ${yerba.size}`, stock: "Quedan 2", price },
  chat: {
    contact: "Cliente",
    by: "Responde Yvyra",
    /** `at`: en qué punto de la conversación (0 a 1) aparece cada mensaje. */
    messages: [
      { from: "client", at: 0, time: "21:14", text: "Buenas, ¿tienen yerba de 1 kg? ¿A cuánto está?" },
      { from: "yvyra", at: 0.3, time: "21:14", text: `Buenas noches. Sí, nos quedan 2 de yerba mate de 1 kg, a ${price}.` },
      { from: "client", at: 0.52, time: "21:15", text: "¿Y hacen envío a Lambaré?" },
      { from: "yvyra", at: 0.76, time: "21:15", text: "Eso lo confirma el encargado. Ya le pasé tu mensaje y te escribe en un rato." },
    ],
    typing: "Yvyra está escribiendo",
    handoff: "Pasado a una persona del local",
    example: "Conversación de ejemplo",
  },
  /** El aviso que entra al final de la conversación y lleva a la vista de Tajy. */
  notice: { title: "Tajy · cámara 2", body: "Pasillo 3, en vivo" },
  tajy: {
    cam: "Cam 02 · Pasillo 3",
    rec: "Rec",
    person: "Persona",
    fallen: "Posible caída",
    gap: "Faltante",
    people: "Personas en el local",
    alertTitle: "Posible caída en el pasillo 3",
    alertBody: "El aviso espera a que alguien del local lo confirme.",
    confirm: "Confirmar",
    dismiss: "Descartar",
    local: "Procesado en el equipo del local",
  },
} as const;
